<template>
    <div data-name="request-status" :class="statusIcon" class="d-flex align-items-center">
        <p>{{ statusText }}</p>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'Status',
    components: {
        Icon
    },
    props: {
        status: String
    },
    computed: {
        statusIcon() {
            switch(this.status) {
                case 'pending':
                    return 'dashboard-pending-status'
                case 'accepted':
                case 'posted':    
                    return 'dashboard-accepted-status'
                case 'declined':
                    return 'dashboard-declined-status'
                case 'cancelled':
                case 'expired':
                    return 'dashboard-canceled-status'
                default:
                    return 'dashboard-pending-status'
            }
        },
        statusText(){
            return this.status === 'accepted' ? 'confirmed' : this.status
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/variables.scss';
div[data-name="request-status"] {
    width: 84px;
    height: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;

    &.dashboard-pending-status {
        background: #FFEBCC;
        p {
            color: #FF9900;
        }
    }
    &.dashboard-accepted-status {
        background: #DCF5E3;
        p {
            color: #2FA84F;
        }
    }
    &.dashboard-declined-status {
        background: #FFF2F5;
        p {
            color: #FA5C7C;
        }
    }
    &.dashboard-canceled-status{
        background: #8d9fa852;
        p {
            color: #8D9FA8;
        }
    }
    p {
        text-transform: uppercase;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 0;
    }
}
</style>